import api from '@/api/api.js'
export default {
  data() {
    return {
      appId:
        process.env.ENV_CONFIG === 'prod'
          ? 'wxd0dbfed69fd5c110'
          : 'wx07f9a91aa1cf5001'
    }
  },
  mounted() {
    console.log(this.appId, '-0d00d0d0d0')
    const shareParam = {
      url: window.location.href.split('#')[0],
      wxType: '5'
    }
    this.$http.post(api.getWxTicket, shareParam).then((res) => {
      wx.config({
        // beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: this.appId, // 必填，企业微信的corpID
        timestamp: res.data.timestamp, // 必填，生成签名的时间戳
        nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
        signature: res.data.signature, // 必填，签名，见 附录-JS-SDK使用权限签名算法
        jsApiList: ['wx-open-launch-weapp'], // 必填，随意一个接口即可
        openTagList: ['wx-open-launch-weapp'] // 填入打开小程序的开放标签名
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/Pdf/PdfDown/mixin/pdfPreview.js